const data = {
  title: "Floor 4-7",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  timeLimitSeconds: 120,
  tilesWidth: 7,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 4,
      y: 4,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 4,
      y: 7,
    },
    {
      type: "WATER",
      x: 6,
      y: 2,
    },
    {
      type: "WATER",
      x: 2,
      y: 6,
    },
    {
      type: "FIRE",
      x: 6,
      y: 4,
    },
    {
      type: "FIRE",
      x: 2,
      y: 4,
    },
    {
      type: "FIRE",
      x: 4,
      y: 6,
    },
    {
      type: "FIRE",
      x: 4,
      y: 2,
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 2,
      direction: "RIGHT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 3,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 6,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 5,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 3,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 2,
      direction: "RIGHT",
    },
    {
      type: "CHIP",
      x: 2,
      y: 6,
    },
    {
      type: "CHIP",
      x: 6,
      y: 2,
    },
    {
      type: "ICE",
      x: 1,
      y: 5,
    },
    {
      type: "ICE",
      x: 1,
      y: 6,
    },
    {
      type: "ICE",
      x: 1,
      y: 2,
    },
    {
      type: "ICE",
      x: 1,
      y: 3,
    },
    {
      type: "ICE",
      x: 3,
      y: 7,
    },
    {
      type: "ICE",
      x: 2,
      y: 7,
    },
    {
      type: "ICE",
      x: 6,
      y: 7,
    },
    {
      type: "ICE",
      x: 7,
      y: 6,
    },
    {
      type: "ICE",
      x: 7,
      y: 5,
    },
    {
      type: "ICE",
      x: 7,
      y: 2,
    },
    {
      type: "ICE",
      x: 5,
      y: 7,
    },
    {
      type: "THIEF",
      x: 4,
      y: 1,
    },
    {
      type: "THIEF",
      x: 1,
      y: 4,
    },
    {
      type: "THIEF",
      x: 7,
      y: 4,
    },
    {
      type: "ICE",
      x: 2,
      y: 1,
    },
    {
      type: "ICE",
      x: 3,
      y: 1,
    },
    {
      type: "ICE",
      x: 5,
      y: 1,
    },
    {
      type: "ICE",
      x: 6,
      y: 1,
    },
    {
      type: "ICE",
      x: 7,
      y: 3,
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 6,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 5,
      direction: "DOWN",
    },
    {
      type: "WATER",
      x: 6,
      y: 6,
    },
    {
      type: "WATER",
      x: 2,
      y: 2,
    },
    {
      type: "CHIP",
      x: 2,
      y: 2,
    },
    {
      type: "CHIP",
      x: 6,
      y: 6,
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 3,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 5,
      direction: "DOWN",
    },
    {
      type: "FIRE_BOOTS",
      x: 1,
      y: 6,
    },
    {
      type: "WATER_PICKUP",
      x: 7,
      y: 2,
    },
    {
      type: "TELEPORT",
      x: 1,
      y: 1,
    },
    {
      type: "TELEPORT",
      x: 3,
      y: 3,
    },
    {
      type: "TELEPORT",
      x: 7,
      y: 1,
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 3,
    },
    {
      type: "TELEPORT",
      x: 1,
      y: 7,
    },
    {
      type: "TELEPORT",
      x: 3,
      y: 5,
    },
    {
      type: "TELEPORT",
      x: 7,
      y: 7,
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 5,
    },
    {
      type: "CHIP",
      x: 6,
      y: 4,
    },
    {
      type: "CHIP",
      x: 4,
      y: 6,
    },
    {
      type: "CHIP",
      x: 2,
      y: 4,
    },
    {
      type: "CHIP",
      x: 4,
      y: 2,
    },
    {
      type: "WATER_PICKUP",
      x: 1,
      y: 2,
    },
    {
      type: "FIRE_BOOTS",
      x: 7,
      y: 6,
    },
  ],
};

export default data;
